import React from 'react'
import {Box, Typography, Card, Divider, Rating, Button, Grid, Stepper, Step, StepLabel} from "@mui/material";
import useStyles from "../../../../assets/styles/ProgramRatingStyles";
import Logo from '../../../../assets/images/dqCitizenshipLogo.png'
import {useHistory} from "react-router-dom";
import {APP_STATUS} from "../../../../utils/constants";
import AddIcon from "@material-ui/icons/Add";
const CPCRatingFullReport = ({ data, actions, options }) => {
    const history = useHistory();
    const classes = useStyles();
    const { pdfUrl, appStatusV3,appStatus,programId,currentStatus,RATING_STEPS } = data;
    const { createAssessmentAction,accessAssessmentAction } = actions;
    const activeStep = RATING_STEPS.findIndex(step => step.status === currentStatus);

    const handleCreateAssessment = () => {
        if (createAssessmentAction) {
            createAssessmentAction();
        }
    };
    const handleAccessAssessment = (programId, appStatus) => {
        if (accessAssessmentAction) {
            accessAssessmentAction(programId, appStatus);
        }
    };
    return (
        <>
            <Box sx={{ backgroundColor:'#F4EEEE', padding:'0px !important' }}>
                <Box sx={{ p: 3 }}>
                    <Stepper
                        activeStep={activeStep}
                        alternativeLabel
                        sx={{
                            '& .MuiStepLabel-root .Mui-completed': {
                                color: '#ff6468ff'
                            },
                            '& .MuiStepLabel-root .Mui-active': {
                                color: '#ff6468ff'
                            },
                            '& .MuiStepLabel-root .Mui-disabled': {
                                color: '#ff6468ff',
                                opacity: 0.5
                            },
                            '& .MuiStepConnector-root .MuiStepConnector-line': {
                                borderColor: '#ff6468ff',
                                borderTopWidth: '6px',
                                // marginTop: '-12px'
                            }
                        }}
                    >
                        {RATING_STEPS.map((step) => (
                            <Step key={step.label}>
                                <StepLabel
                                    StepIconProps={{
                                        sx: {
                                            '&.Mui-completed': {
                                                color: '#ff6468ff',
                                                fontSize: '1.7rem',
                                                '& .MuiStepIcon-text': {
                                                    display: 'none'
                                                }
                                            },
                                            '&.Mui-active': {
                                                color: '#ff6468ff',
                                                fontSize: '1.7rem',
                                                '& .MuiStepIcon-text': {
                                                    display: 'none'
                                                }
                                            },
                                            fontSize: '1.7rem',
                                            '& .MuiStepIcon-text': {
                                                display: 'none'
                                            }
                                        }
                                    }}
                                >
                                    {step.label}
                                </StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                </Box>
                <Typography variant="h3" sx={{ textAlign: "center", marginBottom: 8, marginTop:{xs:'55px', sm:'40px'} }} className={classes.title}>
                    {/*Full CPC Stars Content Rating Report*/}
                    The DQ Stars Report
                </Typography>
                <Typography
                    variant="body1"
                    sx={{
                        fontSize: "1.2rem",
                        textAlign: "center",
                        marginBottom: 2,
                        width: "100%",
                        color: "#474747",
                    }}
                >
                    After reviewing and if you would like to add an impact assessment click the <strong>Add Impact Assessment</strong> {' '}button.
                </Typography>

                    <Box style={{ display: 'flex', justifyContent: 'center', width: '98%' }}>
                        <Button
                            variant="outlined"
                            color="primary"
                            style={{ fontSize: '20px' }}
                            className={classes.dialogButton}
                            onClick={() => handleAccessAssessment(programId, appStatus)}
                        >
                            {
                                appStatus >= APP_STATUS.ASSESSMENTS_READY ? 'Access Assessment' :
                                    appStatus < APP_STATUS.ASSESSMENTS_READY ? 'Add Impact Assessment' : ''
                            }
                        </Button>
                    </Box>

                { appStatusV3 < APP_STATUS.PROGRAM_FULL_REPORT_COMPLETED ?
                    (
                        <Typography variant="h3" sx={{ textAlign: "center", marginBottom: 8, marginTop:{xs:'55px', sm:'40px'} }} className={classes.title}>
                            Full CPC Stars is Pending Review and it will be available once reviewed by our team!
                        </Typography>
                    )
                    :
                    <div style={{backgroundColor: '#F4EEEE', padding: '20px'}}>
                        <iframe
                            src={pdfUrl}
                            width="100%"
                            height="1190px"
                            title="DQ Standards Conformity Test Report"
                            style={{
                                border: '2px solid #ffffff',
                                borderRadius: '15px',
                                backgroundColor: '#F4EEEE',
                            }}
                        />
                    </div>
                }
            </Box>
        </>
    );
}

export default CPCRatingFullReport;
